// test1827
(1827 && 0);
